/**
 * 内容类型
 */
export var E_ResourceSpaceContentType;
(function (E_ResourceSpaceContentType) {
    /**
     * 链接  用于通过链接打开内容（包括引用外部视频，图文等）
     */
    E_ResourceSpaceContentType["Link"] = "link";
    /**
     * 代码块使用
     */
    E_ResourceSpaceContentType["Playbook"] = "playbook";
    /**
     * 上传视频
     */
    E_ResourceSpaceContentType["Video"] = "video";
})(E_ResourceSpaceContentType || (E_ResourceSpaceContentType = {}));
/**
 * 打开方式
 */
export var E_OpenMode;
(function (E_OpenMode) {
    /**
     * 新标签页
     */
    E_OpenMode["NewTab"] = "new_tab";
    /**
     * 弹窗
     */
    E_OpenMode["Popup"] = "popup";
})(E_OpenMode || (E_OpenMode = {}));
export var E_ResourceSpaceContentStatus;
(function (E_ResourceSpaceContentStatus) {
    /**
     * 草稿
     */
    E_ResourceSpaceContentStatus["Draft"] = "draft";
    /**
     * 已上架
     */
    E_ResourceSpaceContentStatus["Active"] = "active";
    /**
     * 已下架
     */
    E_ResourceSpaceContentStatus["Inactive"] = "inactive";
})(E_ResourceSpaceContentStatus || (E_ResourceSpaceContentStatus = {}));
/**
 * 规则类型
 */
export var E_ResourceSpaceContentRuleType;
(function (E_ResourceSpaceContentRuleType) {
    /**
     * 正向作用，包含指定用户
     */
    E_ResourceSpaceContentRuleType["Include"] = "include";
    /**
     * 反向作用，排除指定用户
     */
    E_ResourceSpaceContentRuleType["Exclude"] = "exclude";
})(E_ResourceSpaceContentRuleType || (E_ResourceSpaceContentRuleType = {}));
export var E_ResourceSpaceContentRuleScope;
(function (E_ResourceSpaceContentRuleScope) {
    /**
     * 全部用户
     */
    E_ResourceSpaceContentRuleScope["AllUsers"] = "all_users";
    /**
     * 指定用户
     */
    E_ResourceSpaceContentRuleScope["SelectedUsers"] = "selected_users";
})(E_ResourceSpaceContentRuleScope || (E_ResourceSpaceContentRuleScope = {}));
